import { alpha } from '@mui/system';
import * as yup from 'yup';
import { themeObject, validationsMessages } from '../../../lib';

export const dataProtectionModalStyles = {
    dialog: {
        '& .MuiDialog-container': {
            '& .MuiPaper-root': {
                overflow: 'hidden',
                height: '228px',
                width: '442px',
                borderRadius: '10px',
                boxShadow: `
                0px 6px 30px 5px ${alpha(themeObject.palette.grayScale[700], 0.12)},
                0px 16px 24px 2px ${alpha(themeObject.palette.grayScale[700], 0.14)},
                0px 8px 10px -5px ${alpha(themeObject.palette.grayScale[700], 0.2)},
                `,
            },
        },
    },
    dialogBodyContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        overflowY: 'hidden',
        mb: 3.375,
    },
    dialogContentText: {
        color: themeObject.palette.grayScale[800],
        lineHeight: '21.17px',
    },
    button: {
        mt: 2.5,
    },
};

export const blastChatStyles = {
    chatContainer: {
        mr: 3.375,
        width: '540px',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    chatContentContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
        overflowAnchor: 'auto !important',
        pr: 1.25,
    },
    searchFieldContainer: {
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        pt: '12px',
    },
    searchFieldInputField: {
        height: '50px',
    },
    footerContainer: {
        pt: 1.625,
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
    },
    linkContainer: {
        display: 'flex',
        textAlign: 'left',
    },
    buttonContainer: {
        display: 'flex',
        textAlign: 'right',
    },
    conversationLink: {
        ...themeObject.typography.body1,
        fontSize: '16px',
        fontFamily: 'Red Hat Text',
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
    },
    loadingConversationLink: {
        ...themeObject.typography.body1,
        fontSize: '16px',
        fontFamily: 'Red Hat Text',
        lineHeight: '21.17px',
        color: themeObject.palette.grayScale[800],
        pointerEvents: 'none',
        opacity: 0.5,
    },
};

export const messageStyles = {
    mainContainer: {
        mb: 2,
        '&:last-child': {
            mb: 0,
        },
    },
    cardContent: {
        py: 1.6875,
        pr: 2,
        display: 'flex',
        alignItems: 'center',
        '&:last-child': {
            pb: 1.6875,
        },
    },
    cardContentContainer: {
        display: 'flex',
    },
    pendingCardContentContainer: {
        display: 'flex',
        alignItems: 'center',
        py: 1.6875,
        pr: 2,
    },
    errorCardContentContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    textContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    avatarContainer: {
        pr: 2,
    },
    messageTitle: {
        ...themeObject.typography.body2,
        fontFamily: 'Red Hat Text',
        color: themeObject.palette.grayScale[700],
    },
    messageValue: {
        ...themeObject.typography.body1,
        color: themeObject.palette.grayScale[800],

        '& .markdown': {
            '> p': {
                m: 0,
                mb: 3.5625,
            },
        },
    },
    userMessage: {
        display: 'flex',
        minHeight: '76px',
        backgroundColor: themeObject.palette.background.paper,
        borderRadius: '10px',
        boxShadow: `
             0px 0px 3px 0px ${alpha(themeObject.palette.grayScale[700], 0.2)},
             0px 1px 1px 0px ${alpha(themeObject.palette.grayScale[700], 0.22)},
             0px 2px 1px -1px ${alpha(themeObject.palette.grayScale[700], 0.2)},
            `,
    },
    systemMessage: {
        display: 'flex',
        minHeight: '76px',
        borderRadius: '10px',
        border: `1px solid ${themeObject.palette.grayScale[100]}`,
        backgroundColor: alpha(themeObject.palette.grayScale[100], 0.5),
    },
    errorMessage: {
        display: 'flex',
        minHeight: '76px',
        borderRadius: '10px',
        border: `1px solid ${themeObject.palette.tertiary.red[300]}`,
        backgroundColor: themeObject.palette.tertiary.red[50],
    },
    pendingMessageValue: {
        ...themeObject.typography.body1,
        fontSize: '14px',
        lineHeight: '18.52px',
        color: themeObject.palette.grayScale[700],
    },
    systemAvatar: {
        backgroundColor: 'transparent',
    },
    errorMessageValue: {
        ...themeObject.typography.body2,
        lineHeight: '18.52px',
        fontFamily: 'Red Hat Text',
        color: themeObject.palette.tertiary.red[700],
    },
    errorIconContainer: {
        display: 'flex',
    },
    errorIcon: {
        color: themeObject.palette.tertiary.red[400],
        height: '20px',
        width: '20px',
        mx: 1.25,
        mb: 1.3125,
        mt: 1.1875,
    },
};

export const blastAIChatDefaults = { userPrompt: '' };

export interface BlastAIChatInputs {
    userPrompt: string;
}

export const blastAIChatSchema = yup.object({
    userPrompt: yup.string().required(validationsMessages.required),
});
